import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class LiquidacionRecorridoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    cerrarLiquidacion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $codigoRecorrido: Decimal, $monto: Decimal, $rutUsuario: Decimal, $saldoDocumentoCliente: [recorrido_detalleInputType]) {
            liquidacion_recorrido {
              cerrarLiquidacion(
                rutEmpresa: $rutEmpresa
                sucursalCodigo: $sucursalCodigo
                codigoRecorrido: $codigoRecorrido
                monto: $monto
                rutUsuario: $rutUsuario
                saldoDocumentoCliente: $saldoDocumentoCliente
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.liquidacion_recorrido.cerrarLiquidacion;
            callback({ mensajes, respuesta });
        });
    }
}
LiquidacionRecorridoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LiquidacionRecorridoService_Factory() { return new LiquidacionRecorridoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: LiquidacionRecorridoService, providedIn: "root" });
